var map = {
	"./Step1.svg": 5114,
	"./Step2.svg": 3225,
	"./Step3.svg": 5336,
	"./arrow-list-1.svg": 3917,
	"./arrow-list-2.svg": 1918,
	"./back-2.png": 7259,
	"./back-3.png": 8258,
	"./back-4.png": 9821,
	"./back-5.png": 7316,
	"./back-game-mob.png": 2330,
	"./back-game.png": 7211,
	"./back-inner-1-mob.png": 8998,
	"./back-inner-1.png": 8687,
	"./back-inner-2-mob.png": 3929,
	"./back-inner-2.png": 3412,
	"./back-inner-mob.png": 9972,
	"./back-inner.png": 5677,
	"./back-mob-2.png": 3866,
	"./back-mob-3.png": 4627,
	"./back-mob-4.png": 4668,
	"./back-mob-5.png": 8533,
	"./back-mob-6.png": 9758,
	"./back-prize-mob.png": 9768,
	"./back-prize.png": 4329,
	"./bubble-date.svg": 5050,
	"./cat-image.svg": 2941,
	"./flag-1.png": 4887,
	"./flag-2.png": 60,
	"./flag-3.png": 2949,
	"./flag-4.png": 5002,
	"./game-banner-LK-mob.png": 7427,
	"./game-banner-LK.png": 3638,
	"./icon-close.svg": 8947,
	"./icon-menu.svg": 7268,
	"./icon-search.svg": 2425,
	"./icon-user.svg": 7408,
	"./image-main-mob.png": 8849,
	"./image-main.png": 7884,
	"./image-prod-detailed-02.png": 860,
	"./image-sample.png": 7381,
	"./image-zagl-mob.png": 7424,
	"./image-zagl.png": 2017,
	"./logo-1.svg": 4736,
	"./logo-2.svg": 5491,
	"./logo-3.svg": 322,
	"./logo-4.svg": 541,
	"./logo-5.svg": 1596,
	"./logo-6.svg": 623,
	"./logo-mf.svg": 9906,
	"./mail-icon.svg": 9216,
	"./ok-icon.svg": 5061,
	"./pack-main-trnsp.png": 898,
	"./pack-main.png": 5056,
	"./prize 1 0.svg": 4416,
	"./prize 1.svg": 544,
	"./prize 2 0.svg": 5995,
	"./prize 2.svg": 9939,
	"./prize 3 0.svg": 8882,
	"./prize 3.svg": 6626,
	"./prize 4.svg": 557,
	"./prize 5.svg": 2012,
	"./prize 6.svg": 4335,
	"./prize 7.svg": 4286,
	"./prize 8 0.png": 43,
	"./prize 8.svg": 1081,
	"./product-1-0175l.png": 8572,
	"./product-1-1l.png": 4284,
	"./product-1-2l.png": 3129,
	"./product-2-0175l.png": 383,
	"./product-2-1l.png": 6817,
	"./product-2-2l.png": 3300,
	"./product-3-0175l.png": 4058,
	"./product-3-1l.png": 6090,
	"./product-3-2l.png": 5115,
	"./product-4-0175l.png": 8013,
	"./product-4-1l.png": 6007,
	"./product-4-2l.png": 6182,
	"./product-5-1l.png": 6960,
	"./product-6-1l.png": 7909,
	"./product-7-0175l.png": 6790,
	"./product-7-1l.png": 4062,
	"./product-7-2l.png": 7119,
	"./product-8-1l.png": 2795,
	"./product-8-2l.png": 1050,
	"./product-9-1l.png": 5236,
	"./product-9-2l.png": 4398,
	"./vk-icon.svg": 1872,
	"./ya-icon.svg": 3085
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1803;